exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.domainSelect[data-v-2ca759e2] {\n\tmargin-top: 0.4em;\n}\n.emailText[data-v-2ca759e2] {\n\ttext-align: right;\n}\n", ""]);

// exports
